export default function MySQL_POSITION() {
  return (
    <div>
      <h2>MySQL_POSITION</h2>    </div>
  );
}